"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CompanyDataImportModal = class CompanyDataImportModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    file;
    headered;
    colnum_number;
    colnum_name;
    colnum_email;
    ux;
    dataMembers = ['file', 'headered', 'colnum_number', 'colnum_name', 'colnum_email', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                file: null,
                headered: true,
                colnum_number: 1,
                colnum_name: 2,
                colnum_email: 3,
                ux: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Import client data"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3626_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_register_3632_getActionArgs($event) {
        return {
            name: "resultLength",
            value: $event.data.response.data ? $event.data.response.data.updated_records : 0,
        };
    }
    async act_5534025912102772_notification_3634_getActionArgs($event) {
        return {
            message: this.$fn.ngettext("One record imported.", "${n} records imported.", $event.data.resultLength),
        };
    }
    async act_5534025912102772_notification_3634_getWhen($event) {
        return $event.data.resultLength > 0;
    }
    async act_5534025912102772_notification_3636_getActionArgs($event) {
        return {
            message: this.$fn.gettext("Nothing has been imported."),
        };
    }
    async act_5534025912102772_notification_3636_getWhen($event) {
        return !$event.data.resultLength;
    }
    async act_5534025912102772_closeModal_3638_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_5534025912102772_reloadSlickgrid_3640_getActionArgs($event) {
        return {
            grid: "all",
        };
    }
    async act_5534025912102772_request_3630_getActionArgs($event) {
        return {
            operation: "import_clients",
            data: { header: this.headered, file: this.file, colnum_number: this.colnum_number, colnum_name: this.colnum_name, colnum_email: this.colnum_email },
        };
    }
    async evh_5534025912102772_submit(event, scope) {
        return await this.actions.evh_5534025912102772_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_3642_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3626 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3626_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3625 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3626,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3625],
        });
        const act_2248226175642056_closeComponent_3628 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3627 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3628,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3627],
        });
        const act_5534025912102772_register_3632 = new core_1.actions.RegisterAction({
            actionArgs: this.act_5534025912102772_register_3632_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_success_3631 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_register_3632,
            event: "success",
            displayName: "register",
        });
        const act_5534025912102772_notification_3634 = new core_1.actions.NotificationAction({
            actionArgs: this.act_5534025912102772_notification_3634_getActionArgs,
            when: this.act_5534025912102772_notification_3634_getWhen,
            events: [],
        });
        const evh_5534025912102772_success_3633 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_notification_3634,
            event: "success",
            displayName: "notification",
        });
        const act_5534025912102772_notification_3636 = new core_1.actions.NotificationAction({
            actionArgs: this.act_5534025912102772_notification_3636_getActionArgs,
            when: this.act_5534025912102772_notification_3636_getWhen,
            events: [],
        });
        const evh_5534025912102772_success_3635 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_notification_3636,
            event: "success",
            displayName: "notification",
        });
        const act_5534025912102772_closeModal_3638 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_5534025912102772_closeModal_3638_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_success_3637 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_closeModal_3638,
            event: "success",
            displayName: "closeModal",
        });
        const act_5534025912102772_reloadSlickgrid_3640 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_5534025912102772_reloadSlickgrid_3640_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_success_3639 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_reloadSlickgrid_3640,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_5534025912102772_request_3630 = new core_1.actions.RequestAction({
            actionArgs: this.act_5534025912102772_request_3630_getActionArgs,
            displayName: "submit",
            events: [evh_5534025912102772_success_3631, evh_5534025912102772_success_3633, evh_5534025912102772_success_3635, evh_5534025912102772_success_3637, evh_5534025912102772_success_3639],
        });
        const evh_5534025912102772_submit_3629 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_request_3630,
            event: "submit",
            displayName: "submit",
        });
        const evh_5534025912102772_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_submit_3629],
        });
        const act_1419464017721962_closeModal_3642 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_3642_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3641 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_3642,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3641],
        });
        return {
            act_7315092382398562_closeModal_3626,
            evh_7315092382398562_close_3625,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3628,
            evh_2248226175642056_close_3627,
            evh_2248226175642056_close,
            act_5534025912102772_register_3632,
            evh_5534025912102772_success_3631,
            act_5534025912102772_notification_3634,
            evh_5534025912102772_success_3633,
            act_5534025912102772_notification_3636,
            evh_5534025912102772_success_3635,
            act_5534025912102772_closeModal_3638,
            evh_5534025912102772_success_3637,
            act_5534025912102772_reloadSlickgrid_3640,
            evh_5534025912102772_success_3639,
            act_5534025912102772_request_3630,
            evh_5534025912102772_submit_3629,
            evh_5534025912102772_submit,
            act_1419464017721962_closeModal_3642,
            evh_1419464017721962_clickPreventStop_3641,
            evh_1419464017721962_clickPreventStop,
            submit: act_5534025912102772_request_3630,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CompanyDataImportModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CompanyDataImportModal.prototype, "onSize", null);
CompanyDataImportModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], CompanyDataImportModal);
exports.default = CompanyDataImportModal;
vue_property_decorator_1.Vue.component("CompanyDataImportModal", CompanyDataImportModal);
